import Vue from 'vue'
import Vuex from 'vuex'
import { getParamSet } from "@/assets/js/apis";

Vue.use(Vuex)

export default new Vuex.Store({
    state: JSON.parse(localStorage.getItem('state')) ? JSON.parse(localStorage.getItem('state')) : {
        bannerContent: ''
    },
    mutations: {
        setParamSet(state, params) {
            state.bannerContent = params;
            localStorage.setItem('state', JSON.stringify(this.state));
            console.log(JSON.parse(localStorage.getItem('state')))
        }
    },
    actions: {
        async getParamSetContent({ commit }) {
            function httpRole(data) {
                console.log('请求参数===>', data) //模拟请求参数
                return new Promise((resolve) => {
                    getParamSet().then((res) => {
                        resolve(res.data);
                    });
                })
            }
            let resp = await httpRole()  //模拟请求
            commit('setParamSet', resp)
        }

    }
})




// WEBPACK FOOTER //
// ./src/store/index.js